export enum EYapePromotionCodeStatus {
  REDEEMED = 'REDEEMED',
  UNREDEEMED = 'UNREDEEMED',
  INACTIVE = 'INACTIVE',
  OBSERVED = 'OBSERVED',
}

export enum EYapePromotionSearchMethod {
  NAME = 'NAME',
  FILTER = 'FILTER',
}

export enum EYapePromoType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum EYapeSection {
  PROMOTION = 'PROMOTION',
  QR = 'QR',
}

export enum EYapeFormError {
  INVALID_CODES = 'SFE1906',
}
